import React, { useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { FaBell, FaUserCircle } from "react-icons/fa";
import { FiAlignJustify, FiX } from "react-icons/fi";
import Sidebar from "../Sidebar/sidebar";
import Portfoliosidebar from "../../Company/Sidebar/Portfoliosidebar";
import { FaPaperPlane } from "react-icons/fa";
import { GoGitCompare  } from "react-icons/go";
import { CiUser } from "react-icons/ci";
import { FaPowerOff } from "react-icons/fa";
import { Dropdown, Image, Badge } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import "./navbar.css";
import { useNavigate } from "react-router-dom";
import { logout as investorLogout } from "../../../controllers/investor/accounts";
import { logout as companyLogout, relationshipLogout as rmLogout } from "../../../controllers/company/accounts";
import { AiOutlineLogout } from "react-icons/ai";
import { Flex, Spin, notification } from "antd";
import InvitePopup from "../InvitePopup";
import {companyLogin} from "../../../controllers/company/accounts";
import { NOIMAGE } from "../../../config/constants";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
const TopNavbar = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showInvite, setShowInvite] = useState(false);
  const toggleShowInvite = () => setShowInvite(!showInvite);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const USERDATA = JSON.parse(sessionStorage.getItem('USER-INFO'));
  const RMUSERDATA = JSON.parse(sessionStorage.getItem('RM-USER-INFO'));
  const RMCOMPANYLIST = JSON.parse(sessionStorage.getItem('RM-COMPANY'));

  const handleLogout = async () =>{
    try {
      if(RMUSERDATA){
        await rmLogout();
        navigate('/');
      } else if(USERDATA?.investor_email){
        await investorLogout();
        navigate('/');
      } else{
        await companyLogout();
        navigate('/');
      }
    } catch (error) {
      sessionStorage.clear();
      localStorage.clear();
      navigate('/');
    }
  }

  const handleCompanyChange = async (items) => {
    try {
      setIsLoading(true);
      if(items?._id !== USERDATA?._id){
        const res = await companyLogin({company_id : items?._id});
        if(res?.result?.first_time_login === true && !RMUSERDATA){
          navigate('/company/profile');
          notification.open({
            message: "Success",
            description: `Welcome to ${res?.result.company_name}`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
        } else{
          notification.open({
            message: "Success",
            description: `Welcome back! ${res?.result.company_name}`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate('/company/dashboard');  
        }
      }
    } catch (error) {
      setIsLoading(false);
    } finally{
      setIsLoading(false);
    }
  }
  
  return (
    <div>
      <div className="chirate_header_main_section">
        <div className="top_bar"  fixed="top"  >
             <Navbar
          bg="light"
          className="px-4"
         style={{ width: "98%", margin: "0 auto", top: "10px" }}
         
        >
          <Navbar.Brand href="javaScript:void(0)" onClick={()=>navigate('/')} className="me-auto navbar_left_logo">
            <img
              src="/charaiteImage/navbar_img.png"
              alt="Logo"
              height="30"
              loading="lazy"
            />
          </Navbar.Brand>
         
          
          <Nav className="d-flex align-items-center">
          
            {/* Switch Account */}
            {(RMUSERDATA && RMCOMPANYLIST && RMCOMPANYLIST?.length > 0) && (
              <Dropdown align="end" className="notification_dropdown">
                <Dropdown.Toggle variant="link" id="notification_dropdown" style={{textDecoration : 'none', color : "#a32532"}} className="d-flex align-items-center ms-3 navbar_user_heading">
                  <GoGitCompare style={{color : "#000000ff"}} className="bell-icon" />
                  <h6>Switch Company</h6>
                </Dropdown.Toggle> 

                <Dropdown.Menu className="dropdown-menu">
                  <div className="dropdown-arrow"></div>
                  <div>
                    <div className="drop_down_notification">
                      <div className="notifications_header">Companies</div>
                      {/* <span className="navbar_recent_notication">
                        Recent Notifications
                      </span> */}
                    </div>
                    {RMCOMPANYLIST.map((items, index)=>(
                      <Dropdown.Item
                        className="notification-item"
                        onClick={(e) => handleCompanyChange(items)} // Prevent dropdown from closing
                        key={index}
                        style={USERDATA._id === items._id ? { border: "2px solid #a32532" } : {}}
                      >
                        <div className="notification_image_with_svg">
                          {/* <img
                            src="/charaiteImage/notification_img.png"
                            alt="notification"
                          /> */}
                          <img
                            src={ items?.company_image || NOIMAGE }
                            alt="Logo"
                            className="profile-logo"
                          />
                          <div>
                            {/* <div className="dropdown_eight_min">8 min ago...</div> */}
                            <div className="notification_title">
                              {items?.company_name}
                            </div>
                            <div className="notification-subtitle">
                              {items?.company_description?.length > 30 ? (`${items.company_description.substr(0,30)}...`):(items.company_description)}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Item>
                    ))}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}

            {(USERDATA && USERDATA?.investor_first_name) && (
              <div className="invite_btn">
                  <button type="button" onClick={toggleShowInvite}>Invite <FaPaperPlane /></button>
              </div>
            )}
          
            {USERDATA?.company_name ? (
             
              <Nav.Link
                onClick={()=>navigate('/company/profile')}
                  href="javaScript:void(0)"
                  className="d-flex align-items-center ms-3 navbar_user_heading"
                >
                  <CiUser className="me-1" />
                  <h6> <span>{USERDATA?.company_name || USERDATA?.investor_first_name}</span> </h6>
              </Nav.Link>
            ):(
              <Nav.Link
                onClick={()=>navigate('/investor/profile')}
                  href="javaScript:void(0)"
                  className="d-flex align-items-center ms-3 navbar_user_heading"
                >
                  <CiUser className="me-1" />
                  <h6> <span>{USERDATA?.company_name || USERDATA?.investor_first_name}</span> </h6>
                </Nav.Link>
            )}
            <Nav.Link href="javaScript:void(0)" onClick={handleLogout}>
              <AiOutlineLogout  className="bell-icon" color="#a32532" />
            </Nav.Link>
            
          </Nav>
          <div className="block md:hidden navbar_hemburger_button">
            {isSidebarOpen ? (
              <FiX
                className="text-dark cursor-pointer text-2xl"
                onClick={toggleSidebar}
              />
            ) : (
              <FiAlignJustify
                className="text-dark cursor-pointer text-2xl"
                onClick={toggleSidebar}
              />
            )}
          </div>
        </Navbar>
        </div>
       
      </div>

      {USERDATA?.investor_email?(
        <Sidebar isSidebarOpen={isSidebarOpen} />
      ):(
        <Portfoliosidebar isSidebarOpen={isSidebarOpen} />
      )}
      <InvitePopup showInvite={showInvite} toggleShowInvite={toggleShowInvite} />
      <Flex align="center" gap="middle">
        <Spin 
            size="large" 
            spinning={isLoading}
            fullscreen={true}
        />
      </Flex>
    </div>
  );
}

export default TopNavbar;